import React from 'react';

const CVPreview = ({ formData, template, color }) => {
  return (
    <div className="bg-white rounded-xl shadow-2xl p-8 min-h-[800px]">
      <div className="text-center mb-6 pb-4 border-b-2" style={{ borderColor: color }}>
        <h1 className="text-3xl font-bold" style={{ color }}>
          {formData.first_name || 'Prénom'} {formData.last_name || 'Nom'}
        </h1>
        {formData.title && (
          <p className="text-lg text-gray-600 mt-2">{formData.title}</p>
        )}
        <div className="flex justify-center items-center space-x-4 mt-3 text-sm text-gray-600">
          {formData.email && <span>📧 {formData.email}</span>}
          {formData.phone && <span>📞 {formData.phone}</span>}
          {formData.location && <span>📍 {formData.location}</span>}
        </div>
      </div>

      {formData.summary && (
        <div className="mb-6">
          <h2 className="text-xl font-bold mb-2" style={{ color }}>
            Profil
          </h2>
          <p className="text-gray-700 text-justify">{formData.summary}</p>
        </div>
      )}

      {formData.experiences.length > 0 && (
        <div className="mb-6">
          <h2 className="text-xl font-bold mb-3" style={{ color }}>
            Expérience Professionnelle
          </h2>
          {formData.experiences.map((exp, index) => (
            <div key={index} className="mb-4">
              <div className="flex justify-between items-start mb-1">
                <div>
                  <h3 className="font-semibold text-gray-900">{exp.position}</h3>
                  <p className="text-sm" style={{ color }}>
                    {exp.company}
                  </p>
                </div>
                <span className="text-sm text-gray-500">
                  {exp.start_date} - {exp.end_date || 'Présent'}
                </span>
              </div>
              {exp.achievements && exp.achievements[0] && (
                <ul className="list-disc list-inside text-sm text-gray-700 mt-2">
                  {exp.achievements[0].split('\n').filter(a => a.trim()).map((achievement, i) => (
                    <li key={i}>{achievement}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      )}

      {formData.education.length > 0 && (
        <div className="mb-6">
          <h2 className="text-xl font-bold mb-3" style={{ color }}>
            Formation
          </h2>
          {formData.education.map((edu, index) => (
            <div key={index} className="mb-3">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-semibold text-gray-900">{edu.degree}</h3>
                  <p className="text-sm text-gray-600">{edu.school}</p>
                </div>
                <span className="text-sm text-gray-500">{edu.year}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {formData.skills.length > 0 && (
        <div className="mb-6">
          <h2 className="text-xl font-bold mb-3" style={{ color }}>
            Compétences
          </h2>
          <div className="flex flex-wrap gap-2">
            {formData.skills.map((skill, index) => (
              <span
                key={index}
                className="px-3 py-1 rounded-full text-sm text-white"
                style={{ backgroundColor: color }}
              >
                {skill}
              </span>
            ))}
          </div>
        </div>
      )}

      {!formData.first_name && !formData.last_name && (
        <div className="flex items-center justify-center h-96 text-gray-400">
          <div className="text-center">
            <svg
              className="w-20 h-20 mx-auto mb-4 opacity-50"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <p className="text-lg font-medium">Aperçu de votre CV</p>
            <p className="text-sm">Remplissez le formulaire pour voir votre CV prendre forme</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CVPreview;
